import { supabase } from "@/lib/supabase";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim() ?? "";
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim() ?? "";

const PENDING_CONSENT_KEY = "daywia_pending_signup_consent";

type PendingConsent = {
  marketingOptIn: boolean;
};

export function savePendingSignupConsent(marketingOptIn: boolean): void {
  const payload: PendingConsent = { marketingOptIn };
  localStorage.setItem(PENDING_CONSENT_KEY, JSON.stringify(payload));
}

export async function recordSignupConsent(marketingOptIn = false): Promise<void> {
  const session = await supabase.auth.getSession();
  const token = session.data.session?.access_token;
  if (!token) throw new Error("Not signed in");

  const purposes = ["account", "feed", "messaging"];
  if (marketingOptIn) purposes.push("marketing");

  const res = await fetch(`${supabaseUrl}/rest/v1/rpc/record_privacy_consent`, {
    method: "POST",
    headers: {
      apikey: anonKey,
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Prefer: "return=minimal",
    },
    body: JSON.stringify({
      p_purposes: purposes,
      p_marketing_opt_in: marketingOptIn,
      p_retention_days: 365,
    }),
  });
  if (!res.ok) {
    throw new Error(`Consent save failed: ${res.status}`);
  }
}

export async function flushPendingSignupConsentIfNeeded(): Promise<void> {
  const raw = localStorage.getItem(PENDING_CONSENT_KEY);
  if (!raw) return;
  let pending: PendingConsent;
  try {
    pending = JSON.parse(raw) as PendingConsent;
  } catch {
    localStorage.removeItem(PENDING_CONSENT_KEY);
    return;
  }
  try {
    await recordSignupConsent(pending.marketingOptIn);
    localStorage.removeItem(PENDING_CONSENT_KEY);
  } catch {
    // Keep pending until the user has a session.
  }
}
